import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=83cf5828&scoped=true"
import script from "./Reload.vue?vue&type=script&lang=js"
export * from "./Reload.vue?vue&type=script&lang=js"
import style0 from "./Reload.vue?vue&type=style&index=0&id=83cf5828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf5828",
  null
  
)

export default component.exports